import { AnimationProps, motion } from 'framer-motion'
import { PropsWithChildren } from 'react'
import { AnimationConfig } from '../utils/variants'

type Props = {
  transition?: AnimationProps['transition']
}

const AnimatedCarouselHeader = ({
  transition,
  children
}: PropsWithChildren<Props>) => {
  return (
    <motion.div
      whileInView={AnimationConfig.variants.visible}
      variants={AnimationConfig.variants.initial}
      initial="hidden"
      transition={transition}
      viewport={AnimationConfig.viewport}
    >
      {children}
    </motion.div>
  )
}

export const Header = AnimatedCarouselHeader
